export const updateCompanyMutation = () => {
    return `mutation UpdateCompany(
        $companyId: Int!,
        $name: String,
        $abbreviation: String,
        $logoUrl: String,
        $isSilo: Boolean
    ) {
        updateCompany(
            companyId: $companyId,
            name: $name,
            abbreviation: $abbreviation,
            logoUrl: $logoUrl,
            isSilo: $isSilo
        ) {
            company {
                id
                name
                abbreviation
                logoUrl
                isSilo
            }
        }
    }`
}
